import React, {Component} from 'react';

class TextContent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 mx-4 pl-4 pr-5 text-left">
                    {this.props.content}
                </div>
            </div>
        );
    }
}

export default TextContent;
